import { Card, CardActions, CardContent, Grid, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { PmiButton } from 'shell/components/shared/button';
import { ReactElement, useCallback } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import * as yup from 'yup';

export interface initalValuesProps {
  id?: number | string;
  code?: string;
  description?: string;
}

interface Props {
  title: string;
  onCancel: () => void;
  onOk: (form: initalValuesProps) => void;
  children?: ReactElement;
  disabled?: boolean;
  forminitialValues?: initalValuesProps;
  isEdit?: boolean;
}

const validationSchema = yup.object({
  id: yup.string().nullable().notRequired(),
  code: yup.string().nullable().required('Il campo è obbligatorio'),
  description: yup.string().nullable().required('La descrizione è obbligatorio'),
});

const SubscriberFormComponent = ({
  title,
  onCancel,
  disabled = false,
  forminitialValues,
  onOk,
  isEdit,
}: Props): React.ReactElement => {
  const onSubmit = useCallback(
    (formValues) => {
      onOk(formValues);
    },
    [onOk]
  );

  const subscriberForm = useFormik({
    initialValues: forminitialValues || {
      code: '',
      description: '',
    },
    validationSchema: validationSchema,
    onSubmit,
    enableReinitialize: true,
  });
  return (
    <>
      <Card raised className="pmi-my-3">
        <form onSubmit={subscriberForm.handleSubmit}>
          <CardContent style={{ padding: '24px' }}>
            <Typography gutterBottom variant="h5" component="h2">
              {title}
            </Typography>
            <div style={{ padding: '24px 0 0 0' }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                  <PmiTextField
                    label="Codice *"
                    id="code"
                    name="code"
                    fullWidth
                    type="text"
                    disabled={disabled || isEdit}
                    value={subscriberForm.values.code}
                    onChange={subscriberForm.handleChange}
                    error={Boolean(subscriberForm.errors.code) && subscriberForm.touched.code}
                    helperText={subscriberForm.errors.code}
                    variant="outlined"
                    inputProps={{
                      maxLength: '5',
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <PmiTextField
                    label="Descrizione *"
                    id="description"
                    name="description"
                    disabled={disabled}
                    value={subscriberForm.values.description}
                    onChange={subscriberForm.handleChange}
                    error={
                      Boolean(subscriberForm.errors.description) &&
                      subscriberForm.touched.description
                    }
                    helperText={subscriberForm.errors.description}
                    fullWidth
                    type="text"
                    variant="outlined"
                    inputProps={{
                      maxLength: '100',
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </CardContent>
          <CardActions style={{ padding: '24px 24px 16px 24px' }}>
            {!disabled ? (
              <PmiButton variant="contained" color="primary" type="submit" disabled={disabled}>
                Conferma
              </PmiButton>
            ) : null}
            <PmiButton variant="outlined" color="cdmBrand" onClick={onCancel}>
              Indietro
            </PmiButton>
          </CardActions>
        </form>
      </Card>
    </>
  );
};

SubscriberFormComponent.displayName = 'subscriber form component';
export default SubscriberFormComponent;
